export default function removeDuplicateMovies(movies) {
  const uniqueMovies = [];
  const movieNames = new Set();

  for (const movie of movies) {
    const movieName = movie.MovieName;
    if (movieName && !movieNames.has(movieName)) {
      uniqueMovies.push(JSON.parse(JSON.stringify(movie)));
      movieNames.add(movieName);
    } else {
      const notUniqueMovie = uniqueMovies.find(
        (movie) => movie.MovieName === movieName
      );
      if (notUniqueMovie) {
        for (const showTime of movie.ShowTimes) {
          if (!notUniqueMovie.ShowTimes.includes(showTime)) {
            notUniqueMovie.ShowTimes.push(showTime);
          }
        }
      }
    }
  }

  // return uniqueMovies;
  return uniqueMovies;
}
